<template>
  <div class = "container">
    <div class = "landing"></div>
    <div class = "overlay"></div>
    <div class = "content">
      <Header color = "white" type="page" />
      <div class = "text">
        <Tcon icon="f-exclamation-triangle-filled" class="exclamation-triangle" />
        <h1>Error</h1>
        <p v-if="authErrorMsg">{{authErrorMsg[this.lang ? this.lang : 'en']}}</p>
        <button v-if="!externalApp" @click = "back()">Back to home</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Tcon from '../iconography/Tcon'
export default {
  name: 'Error',
  components: {
    Header,
    Tcon,
  },
  props: ['authErrorMsg', 'lang'],
  data () {
    return {
      externalApp: true
    }
  },
  created() {
    if (process.env.VUE_APP_EXTERNAL !== 'true') {
      this.externalApp = false
    }
  },
  methods: {
    back () {
      this.$router.push('/welcome')
    }
  }
}
</script>

<style scoped>
.exclamation-triangle {
  padding-bottom: 2.5vh;
  width: 130px;
  fill: #FF585D;
  display: inline-block;
}
.landing {
  background: url('../assets/landing.jpg') no-repeat center center fixed;
  width: 100%;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -10;
  filter: blur(2px);
}

.overlay {
  width: 100%;
  height: 100%;
  background-color: #000;
  position: fixed;
  opacity: 0.7;
}

.container {
  width: 100%;
}

.content .text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  min-height: stretch;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  padding: 2.5vh 5vw;
}

h1 {
  font-size: 3rem;
  font-weight: 300;
  margin: 0;
  padding: 0 5rem;
  text-align: center;
}

p {
  font-size: 1.25rem;
  padding-top: 2rem;
}

button {
  background-color: #229BD8;
  height: 3rem;
  font-size: 1.3rem;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: white;
  width: 10rem;
  border-radius: 0.3rem;
  margin: 3rem auto;
  border: none
}
</style>